import * as React from 'react';
import { StyledAudioPlayer } from './styles';
import UserAgentUtils from '../../utils/userAgent';

interface AudioPlayerProps {
	url: string;
}

class AudioPlayer extends React.Component<AudioPlayerProps, {}> {

	render() {
		const { url } = this.props;
		const isChrome = UserAgentUtils.isChrome();

		return (
			<StyledAudioPlayer
				ref={(audio: HTMLAudioElement) => {
					if (audio && isChrome) {
						audio.setAttribute('controlsList', 'nodownload');
					}
				}}
				controls={true}
				autoPlay={true}
			>
				<source src={url}/>
			</StyledAudioPlayer>
		);
	}

}

export default AudioPlayer;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/AudioPlayer/index.tsx